import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PricingService {
  private base = `${environment.apiUrl}/pricing`;

  constructor(private http: HttpClient) {}

  // Tabelas
  getTables() { return this.http.get<any>(`${this.base}/tables`); }
  getTable(id: number) { return this.http.get<any>(`${this.base}/tables/${id}`); }
  createTable(payload: any) { return this.http.post(`${this.base}/tables`, payload); }
  updateTableById(id: number, payload: any) { return this.http.put(`${this.base}/tables/${id}`, payload); }
  deleteTableById(id: number) { return this.http.delete(`${this.base}/tables/${id}`); }

  // Margem da conta
  getAccountMargin(){ return this.http.get<any>(`${this.base}/account-margin`); }
  updateAccountMargin(margin_add_value: number, margin_type: 'valor' | 'percentual' = 'valor'){ return this.http.put<any>(`${this.base}/account-margin`, { margin_add_value, margin_type }); }

  // Todas as tabelas com seus valores, para as abas do modal de produto
  getAllTablesWithValues(){ return this.http.get<any>(`${this.base}/tables/all`); }

  // Valores da tabela de referência
  getActiveValues(){ return this.http.get<any>(`${this.base}/values`); }
  getActiveTable(){ return this.http.get<any>(`${this.base}/active`); }
}
